import React from 'react';

const AddModuleManagementJobFamilyPage = () => {
  return <div>AddModuleManagementJobFamilyPage</div>;
};

export default AddModuleManagementJobFamilyPage;
